import React, { useState, useEffect } from 'react'
import classNames from 'classnames'
import uniqueId from 'lodash/uniqueId'
import Container from '../container'
import Tabs from '../tabs'
import Accordion from '../accordion'
import { useWindowDimensions } from '../../utilities/general'
import ArrowLink from '../arrow-link'
import styles from './tabs.module.scss'
import shared from '../shared.module.scss'

const TabsSlice = ({ slice }) => {
  const { width } = useWindowDimensions()

  const { items, primary } = slice

  const {
    tabs_accordion_on_mobile,
    tabs_margin_bottom,
    tabs_container_fluid,
    tabs_text_color,
    tabs_background_color
  } = primary

  const [ itemsWithIds, setItemsWithIds ] = useState( [] )

  useEffect( () => {
    setItemsWithIds( items.map( item => ({ id: uniqueId( 'tab-' ), ...item }) ) )
  }, [ items ] )

  const [ open, setOpen ] = useState()

  const toggleAccordion = key => setOpen( key === open ? '' : key )

  return (
    <section
      className={ classNames( styles.tabs, {
        [ shared.margin ]: tabs_margin_bottom,
        [ shared.padding ]: tabs_background_color,
      })}
      style={{
        color: tabs_text_color,
        backgroundColor: tabs_background_color,
      }}
    >
        <Container fluid={ tabs_container_fluid }>
          { !! itemsWithIds.length && (
            <>
              {( ! tabs_accordion_on_mobile || ( tabs_accordion_on_mobile && width >= 768 ) ) && (
                <Tabs
                  className={ styles.tabs }
                  direction="vertical"
                  defaultActive={ itemsWithIds[ 0 ].id }
                  items={ itemsWithIds.map( item => ({ key: item.id, label: item.tabs_title }) )}
                >
                  { itemsWithIds.map( item => (
                    <div
                      key={ item.id }
                      tabKey={ item.id }
                      className={ styles.content }>
                        <div dangerouslySetInnerHTML={{ __html: item.tabs_content.text ? item.tabs_content.html : '' }} />

                        <ArrowLink
                          className={ styles.cta }
                          to={ item.tabs_cta_link.url }
                          text={ item.tabs_cta_link_text }
                          newTab={ item.tabs_cta_link.target === '__blank' }
                          external={ item.tabs_cta_link.type === 'Web' }
                          arrowType={ item.tabs_cta_link_arrow_type }
                          arrowPosition={ item.tabs_cta_link_arrow_position }
                        />
                        
                      </div>
                  ))}
                </Tabs>
              )}

              { tabs_accordion_on_mobile && width < 768 && (
                itemsWithIds.map( item => (
                  <Accordion
                    key={ item.id }
                    title={ item.tabs_title }
                    open={ open === item.id }
                    onToggle={ () => toggleAccordion( item.id ) }
                    className={ styles.accordion }
                    activeClassName={ styles.accordionActive }
                  >
                    <div className={ styles.content } dangerouslySetInnerHTML={{ __html: item.tabs_content.text ? item.tabs_content.html : '' }} />
                  </Accordion>
                ))
              )}
            </>
          )}
        </Container>
      </section>
  )
}

export default TabsSlice
